<template>
  <div class="issueadd" v-dragDiv v-show="addShow">
    <div class="addTitle moveDragDiv">
      <span>模型树</span>
      <i class="el-icon-close" @click="closeArea"></i>
    </div>
    <div class="nav">
      <el-tree ref="tree" class="navTree" :data="datatree" :props="defaultProps" @node-expand="getBranch">
        <div class="custom-tree-node" slot-scope="{ node, data }">
          <div class="labelstl" @click.stop="selectArtifacts(data)" :title="data.label">{{data.label}}</div>
          <i class="el-icon-view hoo" v-if="data.isHide === 1" @click.stop="showorhide(data,node) "></i>
          <i class="closeeye" style="color:#cccccc" v-if="data.isHide ===2" @click.stop="showorhide(data,node) " ></i>
          <i class="el-icon-view" style="color:#cccccc" v-if="data.isHide ===3" @click.stop="showorhide(data,node) " ></i>
        </div>
      </el-tree>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data(){
    return{
      addShow:false,
      tablist: ["", "元件", "楼层"],
      val: 1,
      datatree: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      modelInfos: [],
      clicked: [],
      showeye: [],
    }
  },
  methods:{
    openArea(){
      this.addShow = true;
      this.modelInfos = Monge.Model.getModels();
      this.$nextTick((a) => {
        this.datatree=[]
        this.getModelTreeRootInfo();
      });
    },
    closeArea(){
      this.addShow = false
    },
    getModelTreeRootInfo() {
      const fName = this.$route.query?.fileNames?.split?.(",")?.[0];
      for (let i = 0; i < this.modelInfos.length; i++) {
        let name = this.modelInfos[i].name;
        if ( i == 0) name = fName || name
        const mId = this.modelInfos[i].id;
        const eId = this.modelInfos[i].rootNodeId;
        const children = Monge.Model.getNodeChildren(mId, eId);
        const obj = {
          modelId: mId,
          elementId: eId,
          label: name,
          isHide: 1,
          children: [ { modelId: -1, elementId: -1, }, ],
        };
        this.datatree.push(obj);
      }
    },
    getBranch(data, node) {
      if (!data.children) return;
      data.children.length = 0;
      const mId = data.modelId;
      const eId = data.elementId;
      const children = Monge.Model.getNodeChildren(mId, eId);
      children.forEach(elementId => {
        const childName = Monge.Model.getNodeName(mId, elementId);
        const childObj = { modelId: mId, elementId: elementId, label: childName, isHide: data.isHide, };
        const cc = Monge.Model.getNodeChildren(mId, elementId);
        if (cc.length) {
          childObj.children = [ { modelId: -1, elementId: -1, }, ];
        }
        data.children.push(childObj);
      });
      for (const key in children) {
        
      }
    },
    selectArtifacts(data, Node, self) {
      Monge.Model.Selector.select(data.modelId, data.elementId);
    },

    showorhide(data, node) {
      //isHide  1,2,3,蓝色眼睛，闭眼睛，灰色眼睛
      // data.isHide = !data.isHide;
      if (data.isHide === 1) {
        Monge.Model.ElementOperator.hide(data.modelId, data.elementId);
        data.isHide = 2;
      } else {
        Monge.Model.ElementOperator.show(data.modelId, data.elementId);
        data.isHide = 1;
      }
      if (node.data.children) {
        node.data.children.forEach((item) => {
          item.isHide = data.isHide;
        });
      }

      if (node.level === 1) return;
      this.findParent(node, (pdt) => {
        if (data.isHide === 1) {
          if (pdt.children.some((c) => c.isHide === 2 || c.isHide === 3)) {
            pdt.isHide = 3;
          } else {
            pdt.isHide = 1;
          }
        } else {
          pdt.isHide = 3;
        }
      });
    },
    findParent(node, cb) {
      const parent = node.parent;
      cb(parent.data);
      if (node.level > 2) {
        this.findParent(parent, cb);
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.issueadd{
  position: absolute;
  top: 65px;
  left: 151px;
  width: 280px;
  height: calc(100% - 190px);
  max-height: 770px;
  z-index: 5;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0px 0px 4px 1px rgba(46, 91, 255, 0.17);
  border-radius: 4px;
  .addTitle{
    cursor: move;
    width: 100%;
    height: 50px;
    padding: 0 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #E8EBEF;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    span{
      font-size: 16px;
      font-weight: bold;
    }
    i{
      font-size: 16px;
      cursor: pointer;
    }
  }
  .nav{
    width: 100%;
    height: calc(100% - 50px);
    padding: 10px 0 10px 15px;
    overflow: hidden;
    overflow-y: auto;
    .navTree{
      width: 100%;
      padding-right: 10px;
    }
  }
  .modeltreebox {
    width: 96%;
    height: 560px;
    padding: 5px;
    overflow-y: auto;
    .mainbox {
      width: 100%;
      // height: 556px;
    }
  }
  .custom-tree-node {
    font-size: 14px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .labelstl {
      cursor: pointer;
      user-select: none;
      width: 160px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .labelstl:hover {
      color: #66ccff;
    }
    .closeeye {
      background: url("../images/closeeye.png") no-repeat;
      background-size: 14px 14px;
      width: 14px;
      height: 14px;
      display: block;
    }
    .hoo:hover {
      color: #66ccff;
    }
    i {
      float: right;
      cursor: pointer;
      margin-right: 5px;
    }
  }
}
</style>